import { createPinia, PiniaVuePlugin } from "pinia";
import Vue from "vue";
import piniaPersistPlugin from "pinia-plugin-persist";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPersistPlugin);

export default pinia;
